import type React from "react";
import { useMemo } from "react";
import { get, isEqual } from "lodash";
import { useFormAPI, useFormStore } from "@/widgets/classic-form/form";
import type { LimitToCountryAttributes } from "@/entities/form-metadata";
import { usePageContextQuery } from "@/shared/page-context";
import { USER_COUNTRY_LIMIT } from "./constants";

export const LimitToUserCountry = ({ label }: LimitToCountryAttributes) => {
    const { data: pageContext } = usePageContextQuery();
    const { partnerId } = pageContext;
    const formAPI = useFormAPI();

    const { priority, location } = useFormStore(({ values }) => ({
        priority: get(values, "priority"),
        location: get(values, "location"),
    }));

    const isInputChecked = useMemo(() => {
        const partnerCountry = USER_COUNTRY_LIMIT[String(partnerId) as keyof typeof USER_COUNTRY_LIMIT];
        return (
            partnerCountry &&
            isEqual(priority, partnerCountry.weightGroupName) &&
            isEqual(location, partnerCountry.locationGpids)
        );
    }, [partnerId, priority, location]);

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = e.target.checked;
        const partnerCountry = USER_COUNTRY_LIMIT[String(partnerId) as keyof typeof USER_COUNTRY_LIMIT];

        if (isChecked && partnerCountry) {
            formAPI.setFieldValue("priority", partnerCountry.weightGroupName);
            formAPI.setFieldValue("location", partnerCountry.locationGpids);
        } else {
            formAPI.setFieldValue("priority", "");
            formAPI.setFieldValue("location", []);
        }
    };

    return (
        <>
            <input
                id="onlyRecordsFrom"
                type="checkbox"
                className="checkbox SFS_mr-12"
                checked={isInputChecked}
                onChange={handleCheckboxChange}
            />
            <label htmlFor="onlyRecordsFrom">{label}</label>
        </>
    );
};
